import React, { createContext, useContext, useState } from 'react'
import data from 'data/data.json'

import { Painting, Images, Hero } from 'models/painting'

type PaintingContextValue = {
  painting: Painting
  setPainting: React.Dispatch<React.SetStateAction<Painting>>
  paintings: Painting[]
  setPaintings: React.Dispatch<React.SetStateAction<Painting[]>>
}

const PaintingContext = createContext<PaintingContextValue>(
  {} as PaintingContextValue
)
export function usePainting() {
  return useContext(PaintingContext)
}

export function PaintingProvider({ children }) {
  const hero: Hero = {
    small: '',
    large: '',
  }
  const images: Images = {
    thumbnail: '',
    hero: hero,
    gallery: '',
  }
  const initialFormState = {
    id: 0,
    name: '',
    year: 0,
    description: '',
    source: '',
    images: images,
    artist: '',
    isPortrait: false,
  }

  const [painting, setPainting] = useState<Painting>(initialFormState)
  const [paintings, setPaintings] = useState<Painting[]>(data.paintings)
  const contextValue: PaintingContextValue = {
    painting,
    setPainting,
    paintings,
    setPaintings,
  }

  return (
    <PaintingContext.Provider value={contextValue}>
      {children}
    </PaintingContext.Provider>
  )
}
